export default "__VITE_ASSET__ewT24x9J__"